// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"ab40306d","51":"60c716b0","413":"7a51dacf","523":"712a335c","620":"7f53b3d9"}[chunkId] + ".chunk.js";
};